import React from 'react';

const axios = require('axios').default;
import Popup from "reactjs-popup";
import RichEditor from '../../RichEditor/components/RichEditor';
import { richTextToHtml } from '../../shared/utils/richTextHtml';

const modalContentStyle = {
  "textAlign": "left",
  "border": "none",
  "borderRadius": "8px",
  "boxShadow": "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
  "width": "1140px",
  "padding": "15px",
  "background": "var(--od-surface, #fff)"
}

const createNoteTemplate = (csrfToken, teamId, noteTemlate, successCallback) => {
  axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

  axios.post(`/teams/${teamId}/note_templates`, {
    note_template: {
      title: noteTemlate.title,
      body: noteTemlate.body
    }
  })
  .then(response => {
    successCallback(response.data);
  })
  .catch(error => {
    const messages = error.response?.data;
    toast.error(Array.isArray(messages) ? messages.join(", ") : "Couldn't create note template.", {
      position: toast.POSITION.TOP_CENTER,
      draggable: false,
      closeOnClick: false,
      autoClose: 5000,
      hideProgressBar: true
    });
  });
};

const NoteTemplateForm = ({
  csrfToken,
  teamId,
  noteTemplates,
  noteTemplatesChanged,
  eventTemplateForForm,
  eventTemplateForFormChanged
}) => {
  return (
    <Popup
      modal
      contentStyle={modalContentStyle}
      closeOnDocumentClick={false}
      className={"popup-modal"}
      onOpen={e => {
        e.stopPropagation();
        e.preventDefault();

        eventTemplateForFormChanged({
          ...eventTemplateForForm,
          newNoteTemplate: {}
        });
      }}
      trigger={open => (
        <button
          type="button"
          className="team-btn-secondary"
          onClick={e => { e.preventDefault(); }}
        >
          <i className="far fa-plus mr-2"></i>
          New Note Template
        </button>
      )}
    >
      {close => (
        <div className="popup-modal-container">
          {eventTemplateForForm.newNoteTemplate ? (
            <div className="row">
              <div className="col-12">
                <div className="row">
                  <div className="col-8">
                    <div className="form-group mb-0">
                      <input
                        type="text"
                        autoFocus={true}
                        style={{'fontSize': "24px", 'color': "var(--sl-text-primary)"}}
                        className="form-control no-border strong shadow-none pl-0 pb-0"
                        value={eventTemplateForForm.newNoteTemplate.title || ""}
                        placeholder="Untitled"
                        onChange={e => {
                          eventTemplateForFormChanged({
                            ...eventTemplateForForm,
                            newNoteTemplate: {
                              ...eventTemplateForForm.newNoteTemplate,
                              title: e.target.value
                            }
                          });
                        }} />
                    </div>
                  </div>
                  <div className="col-4 d-flex justify-content-end align-items-center text-right">
                    <button
                      className="btn btn-primary ml-2"
                      disabled={false}
                      onClick={e => {
                        createNoteTemplate(csrfToken, teamId, eventTemplateForForm.newNoteTemplate, (data) => {
                          noteTemplatesChanged([
                            ...noteTemplates,
                            data
                          ]);

                          eventTemplateForFormChanged({
                            ...eventTemplateForForm,
                            notes: [
                              ...eventTemplateForForm.notes,
                              data
                            ]
                          });

                          close();
                        });
                      }}
                    >
                      Create Note Template
                    </button>
                    <a href="#"
                       onClick={e => {
                         e.preventDefault();
                         close();
                       }}
                       className="text-muted ml-4 mr-2">
                      <i className="fal fa-times"></i>
                    </a>
                  </div>
                  <div className="col-12 pt-3">
                    <RichEditor
                      editorState={eventTemplateForForm.newNoteTemplate.editorState}
                      editorStyle={{"minHeight": "320px"}}
                      onEditorStateChange={editorState => {
                        const noteBody = richTextToHtml(editorState.getCurrentContent());

                        eventTemplateForFormChanged({
                          ...eventTemplateForForm,
                          newNoteTemplate: {
                            ...eventTemplateForForm.newNoteTemplate,
                            body: noteBody,
                            editorState: editorState
                          }
                        });
                      }} />
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        </div>
      )}
    </Popup>
  );
};

export default NoteTemplateForm;
